import React, { useEffect, createElement } from 'react';
const BUSINESS_ID = 'https://langlerair.com.au/#localbusiness';
const WEBSITE_ID = 'https://langlerair.com.au/#website';
const WEBPAGE_ID = 'https://langlerair.com.au/#webpage';
const FAQ_ID = 'https://langlerair.com.au/#faq';
const services = [{
  id: 'https://langlerair.com.au/#service-ducted',
  type: 'Ducted reverse cycle air conditioning installation',
  desc: 'Whole home ducted reverse cycle systems with zoning. Mitsubishi Electric, Daikin and Rinnai HRV.',
  low: 10000,
  high: 20000
}, {
  id: 'https://langlerair.com.au/#service-split',
  type: 'Split system air conditioning installation',
  desc: 'Single and multi head split system installations for individual rooms or multi room solutions.',
  low: 2500,
  high: 8000
}, {
  id: 'https://langlerair.com.au/#service-reverse',
  type: 'Reverse cycle air conditioning installation',
  desc: 'Heating and cooling combined. Both split and ducted reverse cycle systems available.',
  low: 2500,
  high: 18000
}, {
  id: 'https://langlerair.com.au/#service-commercial',
  type: 'Commercial HVAC installation',
  desc: 'Design and supply install for Perth offices, retail, warehouses and trades.',
  low: 5000,
  high: 80000
}];
const faqAnswers = [{
  q: 'How much does air conditioning installation cost in Perth?',
  a: 'Air conditioning installation in Perth typically ranges from A$2,500 for a single split system up to A$20,000 for a complete ducted reverse cycle system. Commercial installs range A$5,000 to A$80,000. Langler Air provides free on site quotes with fixed pricing in writing.'
}, {
  q: 'Do you service my suburb in Perth?',
  a: 'Yes. Langler Air installs across all Perth metropolitan suburbs from our Balcatta workshop, including Karrinyup, Subiaco, Hillarys, Joondalup, Mount Lawley, Sorrento, Duncraig and all surrounding areas.'
}, {
  q: 'Which brand of air conditioner is best for Perth?',
  a: 'Mitsubishi Electric, Daikin and Rinnai HRV are the most reliable brands for Perth conditions. Langler Air is a Mitsubishi Electric Diamond Dealer and installs all three.'
}, {
  q: 'How long does air conditioning installation take?',
  a: 'Most split system installations are completed in a day. Ducted reverse cycle installations typically take 2 to 3 days depending on the size of the home and the number of zones.'
}, {
  q: 'Do you offer a warranty on air conditioning installation?',
  a: 'Yes. Langler Air provides a workmanship guarantee on every installation, plus full manufacturer warranty on all major brand units we install.'
}, {
  q: 'Can I get finance for an air conditioning install?',
  a: 'Yes. Langler Air offers finance through accredited providers. Ask our team at your free quote for current terms.'
}, {
  q: 'Do you remove the old unit?',
  a: 'Yes. Removal and responsible disposal of the existing system is included in every Langler Air installation quote.'
}, {
  q: 'How quickly can you install?',
  a: 'Replacement timing depends on stock and your availability. New installation dates are scheduled at the on-site quote and provided clearly in writing.'
},
// AEO Answer Hub questions, schema-aligned for SBO coverage
{
  q: 'How much does ducted aircon cost in Perth?',
  a: 'Ducted reverse cycle installation in Perth typically ranges A$10,000 to A$20,000 fully installed, depending on home size, zoning and brand. Langler Air quotes fixed price on site.'
}, {
  q: 'What is reverse cycle air conditioning?',
  a: 'Reverse cycle uses one system to heat and cool. It is the most cost effective way to heat a Perth home, working efficiently down to about five degrees outside.'
}, {
  q: 'What size air conditioner do I need?',
  a: 'Sizing depends on room dimensions, ceiling height, insulation and orientation. Every Langler Air recommendation starts with an on-site assessment; no online calculator replaces a proper site visit.'
}, {
  q: 'Is Langler Air a licensed installer?',
  a: 'Yes. Langler Air is a Mitsubishi Electric Diamond Dealer and operates under a licensed refrigeration mechanic in Western Australia, family run from Balcatta since 1995.'
}, {
  q: 'Does Langler Air install Mitsubishi Electric air conditioners?',
  a: 'Yes. Langler Air is an authorised Mitsubishi Electric Diamond Dealer in Perth and installs the full Mitsubishi Electric residential and commercial range.'
}, {
  q: 'Does Langler Air install Daikin air conditioners?',
  a: 'Yes. Langler Air is an authorised Daikin specialist installer in Perth covering the full Daikin residential and commercial range.'
}, {
  q: 'Does Langler Air install Rinnai air conditioners?',
  a: 'Yes. Langler Air installs Rinnai HRV ducted reverse cycle systems across Perth metropolitan area.'
}, {
  q: 'Where is Langler Air located?',
  a: 'Langler Air operates from Unit 2/3 Cressall Rd, Balcatta WA 6021. We install across all Perth metropolitan suburbs.'
}];
const localBusiness = {
  '@type': ['HVACBusiness', 'LocalBusiness'],
  '@id': BUSINESS_ID,
  name: 'Langler Air',
  alternateName: 'Langler Air Pty Ltd',
  url: 'https://langlerair.com.au/',
  logo: 'https://langlerair.com.au/wp-content/uploads/2026/05/langler-logo.webp',
  image: 'https://langlerair.com.au/wp-content/uploads/2026/05/langler-logo.webp',
  description: 'Langler Air, Perth air conditioning installer since 1995. Mitsubishi Electric Diamond Dealer. Supply and installation of reverse cycle, ducted and split systems across Perth metropolitan area. Family run from Balcatta.',
  slogan: 'On-site assessment. Fixed price in writing.',
  award: 'Mitsubishi Electric Diamond Dealer',
  foundingDate: '1995-01-01',
  telephone: '+61864043888',
  email: 'info@langlerair.com.au',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Unit 2/3 Cressall Rd',
    addressLocality: 'Balcatta',
    addressRegion: 'WA',
    postalCode: '6021',
    addressCountry: 'AU'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -31.8753,
    longitude: 115.82
  },
  areaServed: [{
    '@type': 'State',
    name: 'Western Australia'
  }, {
    '@type': 'City',
    name: 'Perth'
  }, {
    '@type': 'City',
    name: 'Joondalup'
  }, {
    '@type': 'City',
    name: 'Wanneroo'
  }, {
    '@type': 'City',
    name: 'Stirling'
  }, {
    '@type': 'City',
    name: 'Subiaco'
  }],
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
    opens: '09:00',
    closes: '16:00'
  }, {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: 'Friday',
    opens: '09:00',
    closes: '14:00'
  }],
  priceRange: 'A$2,500 to A$80,000',
  paymentAccepted: ['Cash', 'EFTPOS', 'Credit Card', 'Bank Transfer', 'Finance'],
  currenciesAccepted: 'AUD',
  knowsAbout: ['ducted reverse cycle air conditioning', 'split system air conditioning', 'reverse cycle air conditioning', 'Mitsubishi Electric air conditioners', 'Daikin air conditioners', 'Rinnai HRV air conditioners', 'commercial HVAC', 'aircon removal Perth', 'zoned cooling systems', 'iZone smart home zoning'],
  // Rule 58: AggregateRating emitted ONCE, only on LocalBusiness @id.
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: '75',
    bestRating: '5',
    worstRating: '1'
  },
  sameAs: ['https://www.instagram.com/LanglerAir/', 'https://www.facebook.com/langlerair/', 'https://www.linkedin.com/company/langler-air/', 'https://www.youtube.com/@langlerair', 'https://abr.business.gov.au/ABN/View?abn=87134927585'],
  taxID: 'ABN 87 134 927 585',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Langler Air installation services',
    itemListElement: services.map(s => ({
      '@type': 'Offer',
      itemOffered: {
        '@id': s.id
      },
      priceCurrency: 'AUD',
      priceSpecification: {
        '@type': 'PriceSpecification',
        minPrice: s.low,
        maxPrice: s.high,
        priceCurrency: 'AUD'
      }
    }))
  }
};
const website = {
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  url: 'https://langlerair.com.au/',
  name: 'Langler Air',
  publisher: {
    '@id': BUSINESS_ID
  },
  inLanguage: 'en-AU',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://langlerair.com.au/?s={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
};
const webpage = {
  '@type': 'WebPage',
  '@id': WEBPAGE_ID,
  url: 'https://langlerair.com.au/',
  name: 'Perth Air Conditioning Installation, Langler Air',
  isPartOf: {
    '@id': WEBSITE_ID
  },
  about: {
    '@id': BUSINESS_ID
  },
  primaryImageOfPage: 'https://langlerair.com.au/wp-content/uploads/2026/05/langler-logo.webp',
  speakable: {
    '@type': 'SpeakableSpecification',
    cssSelector: ['.aeo-answer', 'h1', '.hero-sub']
  },
  breadcrumb: {
    '@id': 'https://langlerair.com.au/#breadcrumb'
  }
};
const breadcrumb = {
  '@type': 'BreadcrumbList',
  '@id': 'https://langlerair.com.au/#breadcrumb',
  itemListElement: [{
    '@type': 'ListItem',
    position: 1,
    name: 'Home',
    item: 'https://langlerair.com.au/'
  }]
};
const faqPage = {
  '@type': 'FAQPage',
  '@id': FAQ_ID,
  isPartOf: {
    '@id': WEBPAGE_ID
  },
  mainEntity: faqAnswers.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: f.a
    }
  }))
};
const serviceBlocks = services.map(s => ({
  '@type': 'Service',
  '@id': s.id,
  serviceType: s.type,
  name: s.type,
  description: s.desc,
  areaServed: {
    '@type': 'State',
    name: 'Western Australia'
  },
  provider: {
    '@id': BUSINESS_ID
  },
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'AUD',
    lowPrice: s.low,
    highPrice: s.high
  }
}));
const graph = {
  '@context': 'https://schema.org',
  '@graph': [localBusiness, website, webpage, breadcrumb, faqPage, ...serviceBlocks]
};
export function Schema() {
  // Inject head-only meta + link tags client side (project has minimal index.html)
  useEffect(() => {
    const tags: HTMLElement[] = [];
    const addMeta = (attr: 'name' | 'property', key: string, content: string) => {
      const m = document.createElement('meta');
      m.setAttribute(attr, key);
      m.setAttribute('content', content);
      document.head.appendChild(m);
      tags.push(m);
    };
    const addLink = (rel: string, href: string, extra?: Record<string, string>) => {
      const l = document.createElement('link');
      l.setAttribute('rel', rel);
      l.setAttribute('href', href);
      if (extra) Object.entries(extra).forEach(([k, v]) => l.setAttribute(k, v));
      document.head.appendChild(l);
      tags.push(l);
    };
    document.documentElement.lang = 'en-AU';
    addMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    addMeta('name', 'ai-content-declaration', 'human-authored');
    addMeta('name', 'description', 'Perth air conditioning installation by Langler Air. Mitsubishi Electric Diamond Dealer, family run from Balcatta since 1995. Free on-site assessments and fixed price quotes in writing. 5.0 from 75 Google reviews.');
    // OpenGraph
    addMeta('property', 'og:title', "Perth's Most Trusted Air Conditioning Installer Since 1995, Langler Air");
    addMeta('property', 'og:description', 'Free on-site assessments and fixed price quotes from Langler Air. Mitsubishi Electric Diamond Dealer. 5.0 from 75 Google reviews.');
    addMeta('property', 'og:url', 'https://langlerair.com.au/');
    addMeta('property', 'og:type', 'website');
    addMeta('property', 'og:locale', 'en_AU');
    addMeta('property', 'og:site_name', 'Langler Air');
    addMeta('property', 'og:image', 'https://langlerair.com.au/wp-content/uploads/2026/05/langler-og.jpg');
    // Twitter
    addMeta('name', 'twitter:card', 'summary_large_image');
    addMeta('name', 'twitter:title', "Perth's Most Trusted Air Conditioning Installer Since 1995");
    addMeta('name', 'twitter:description', 'Free on-site assessments and fixed price quotes from Langler Air. Mitsubishi Diamond Dealer.');
    addMeta('name', 'twitter:image', 'https://langlerair.com.au/wp-content/uploads/2026/05/langler-og.jpg');
    addLink('canonical', 'https://langlerair.com.au/');
    addLink('alternate', 'https://langlerair.com.au/llms.txt', {
      type: 'text/plain',
      title: 'LLMs Text'
    });
    return () => {
      tags.forEach(t => t.remove());
    };
  }, []);
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(graph)
  }} data-id="element-651" data-mp="2oaenkbgkgkv8" />;
}